"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.middleEastCountries = void 0;
exports.middleEastCountries = ["SAR", "AED", "OMR", "BHD", "KWD", "QAR"];
